import React from 'react';
const CHECKOUT_URL = 'https://www.upreferr.com/cart/44596916224135:1';
export function Nav() {
  const goToCheckout = () => {
    window.location.href = CHECKOUT_URL;
  };
  return <nav className="sticky top-10 z-40 bg-white shadow-sm" data-id="element-138">
      <div className="container mx-auto px-6 lg:px-12 py-4 flex items-center justify-between" data-id="element-139">
        <h1 className="text-xl lg:text-2xl font-bold text-[#2D5A34]" data-id="element-140">
          Código Hormonal 40+
        </h1>
        <button onClick={goToCheckout} className="bg-[#C2856A] text-white px-4 py-2 rounded-full text-sm font-semibold hover:bg-[#B37659] transition-colors" data-id="element-141">
          COMPRAR AHORA — $8.49
        </button>
      </div>
    </nav>;
}